import { render, staticRenderFns } from "./FBlockDetail.vue?vue&type=template&id=b4d134c6&"
import script from "./FBlockDetail.vue?vue&type=script&lang=js&"
export * from "./FBlockDetail.vue?vue&type=script&lang=js&"
import style0 from "./FBlockDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports